import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class BadgeService {
  private badges: Map<string, BehaviorSubject<number>>;

  constructor() {
    this.badges = new Map();
  }

  getBadgeSubject(key: string): BehaviorSubject<number> {
    if (!this.badges.has(key)) {
      this.badges.set(key, new BehaviorSubject<number>(0));
    }

    return this.badges.get(key);
  }

  getBadgeCounter(key: string): Observable<number> {
    return this.getBadgeSubject(key).asObservable();
  }

  incrementBadgeCounter(key: string): void {
    this.getBadgeSubject(key).next(this.getBadgeSubject(key).getValue() + 1);
  }

  decrementBadgeCounter(key: string): void {
    this.getBadgeSubject(key).next(this.getBadgeSubject(key).getValue() - 1);
  }

  setBadgeCounter(key: string, value: number): void {
    this.getBadgeSubject(key).next(value);
  }

  resetBadgeCounter(key: string): void {
    this.getBadgeSubject(key).next(0);
  }
}
